import { useEffect } from 'react';

const intervalMs = 60_000;

export function useOperationsRefresh(refresh: () => void) {
  useEffect(() => {
    const onFocus = () => refresh();
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') refresh();
    };
    const timer = window.setInterval(() => {
      if (document.visibilityState === 'visible') refresh();
    }, intervalMs);
    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener('focus', onFocus);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, [refresh]);
}
